import { useParams } from "react-router";
import "./SubmissionView.css";
import { findClassroom } from "../TeacherHomeScreen/FilteringFromURLFunctions";
import { useSelector } from "react-redux";
import { RootState } from "../../../../state/configureStore";
import AssignmentReport from "../../../../components/AssignmentReport";

const SubmissionView = () => {
  // Get attributes classId, studentId and assignmentId from url
  const { classId, studentId, assignmentId } =
    useParams<{ classId: string; studentId: string; assignmentId: string }>();

  // Get teacher data from store
  const classrooms = useSelector((state: RootState) => state.teacherState.classrooms);
  const students = useSelector((state: RootState) => state.teacherState.students);
  const assignments = useSelector((state: RootState) => state.teacherState.assignments);
  const assignmentClasses = useSelector((state: RootState) => state.teacherState.assignmentClasses);

  // filter teacher data to get applicable classroom, student, and assignment
  const classroom = findClassroom(classrooms, classId) ?? undefined;
  const student = students[studentId] ?? undefined;
  const assignment = assignments[assignmentId] ?? undefined;
  const assignmentClass = assignmentClasses[assignmentId]?.[classId] ?? undefined;

  // check if class exists
  if (!classroom) {
    return <p>Classroom does not exist.</p>;
  }

  // check if student exists
  if (!student) {
    return <p>Student does not exist.</p>;
  }

  // check if assignment exists
  if (!assignment) {
    return <p>Assignment does not exist</p>;
  }

  // check if student in class
  if (!classroom?.students[studentId]) {
    return <p>Student not in class.</p>;
  }

  // check if assignment in the class
  if (!assignmentClass) {
    return <p>Assignment has not been assigned to this class</p>;
  }

  // check if assignment has been assigned to student in class
  if (!assignmentClass.students[studentId]) {
    return <p>Student has not been assigned the assignment</p>;
  }

  return <AssignmentReport />;
};

export default SubmissionView;
